<mat-card class="typing-message" [attr.data-testid]="testIds.containerTypingmessage">
  <mat-card-content class="msg-content" [attr.data-testid]="testIds.contentTypingmessage">
    <span class="typing-text" [attr.data-testid]="testIds.textTypingmessage">
      @if (typingUsers().length === 1) {
        <span [attr.data-testid]="testIds.textSingleuserTyping"> {{ typingUsers()[0] }} schreibt </span>
      }
      @if (typingUsers().length > 1) {
        <span [attr.data-testid]="testIds.textMultipleusersTyping"> {{ typingUsers().join(', ') }} schreiben </span>
      }
    </span>
    @if (typingUsers().length > 0) {
      <div class="typing-dots">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    }
  </mat-card-content>
</mat-card>
